import { Dialog, DialogBody, DialogContent, DialogHeader, DialogTitle } from '@cutilei/ui'
import ScheduleList from 'components/Lists/ScheduleList'
import { DateTime } from 'luxon'

import {
  Container
} from './styles'

export default function DailyCutileiServicesModal ({
  visible,
  schedules = [],
  onClose: handleClose
}) {
  if (!schedules || schedules.length === 0) return null
  const { business } = schedules[0]
  const day = DateTime.fromISO (schedules[0].date).toFormat ('dd/MM/yyyy')

  return (
    <Dialog open={visible} onOpenChange={open => { if (!open) handleClose() }}>
      <DialogContent size='xl' aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>Agendamentos - {business.name} ({day})</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Container>
            <ScheduleList
              schedules={schedules}
              total={schedules.length}
              style={{ marginBottom: 0 }}
            />
          </Container>
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}
